import { TabConfig } from '@shared/models/table-config.model';

export const errorTabConfig: TabConfig[] = [
  {
    name: 'Error',
    dataKey: 'error',
    templateKey: 'error',
  },
];
